/*
 * Copyright (c) 2020. Dave van Rijn Development
 */

import IDate from '@dvrd/idate';
import './settings';
import {polyfill} from "seamless-scroll-polyfill";

declare global {
    interface Window {
        mode: string;
        settings: Record<string, any>;
        modeSettings: Record<string, any>;
        allowCookies: boolean;
        dataLayer: any;
        gtag?: Function;
    }
}

IDate.setLocale('NL-nl');

polyfill({});